<template>
    <div class="banner-cont">
        <div
            class="banner-card my-auto"
            v-for="(item, index) in itemBanner"
            :key="index"
            v-bind:style="{ 'background-image': 'url(' + item.img + ')' }"
        >
            <div class="bg-center ">
                <a :href="item.link" :target="target">
                    <div no-gutters class="banner-box">
                        <div class="text-title">
                            {{ item.title }}
                        </div>
                        <div class="text-sub-title">
                            {{ item.subTitle }}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        itemBanner: Array,
        target: {
            type: String,
            default: "_self"
        }
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.banner-cont {
    display: flex;
    justify-content: center;
    gap: 35px;
}

.banner-card {
    display: table;
    position: relative;
    cursor: pointer;
    /* width: $btn-bg-vw;
  height: calc(#{$btn-bg-vw} / 2.5); */
    //max-width: 610px;
    //max-height: 244px;
    width: 42.4vw;
    height: 17vw;
    aspect-ratio: 5/2;
    background: radial-gradient(
        50% 50% at 50% 50%,
        rgba(10, 91, 19, 0) 0%,
        rgba(10, 47, 7, 0.6) 100%
    );
    border-radius: 2.63889vw;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;

    -webkit-transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    box-shadow: 0 -10px 10px rgba(0, 0, 0, 0.4);
    transition: all 0.3s ease-out 0.3s;

    &:hover {
        -webkit-transform: perspective(1000px) rotateX(-10deg) rotateY(19deg)
            rotateZ(0deg);
        transform: perspective(1000px) rotateX(-10deg) rotateY(19deg)
            rotateZ(0deg);
        box-shadow: 0 0 10px rgba(31, 105, 59, 0.3);
    }

    a,
    a:hover {
        text-decoration: none !important;
    }
    .banner-box {
        cursor: pointer;
    }
    .text-title {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        font-size: 3.125vw; //$section-title;
        line-height: calc(3.125vw + 9px);
        text-align: center;
        letter-spacing: 0.04em;
        color: $primary-4;
        margin-bottom: 15px;

        @media only screen and (min-width: 1440px) {
            font-size: 3.125vw; //45px;
        }
    }
    .text-sub-title {
        font-family: Exo;
        font-style: normal;
        font-weight: bold;
        font-size: 1.388888vw; //$section-sub-title;
        // line-height: 21px;
        line-height: calc(#{$section-sub-title} + 10px);
        text-align: center;
        text-transform: uppercase;
        color: $primary-4;
        //padding: 0 5px;

        @media only screen and (min-width: 1440px) {
            font-size: 1.388888vw; //20px;
        }
    }
    .bg-blur {
        width: 100%;
        height: 100%;
        background: radial-gradient(
            50% 50% at 50% 50%,
            rgba(10, 91, 19, 0) 0%,
            rgba(10, 47, 7, 0.6) 100%
        );
        border-radius: 38px;
    }
    .bg-center {
        display: table-cell;
        vertical-align: middle;
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .banner-card {
        width: 335px;
        height: 134px;
        border-radius: 20px !important;
        .bg-blur {
            border-radius: 20px !important;
        }
        .banner-box {
            margin-top: 15px !important;
        }
        .text-title {
            font-size: 28px !important;
            line-height: 34px !important;
        }
        .text-sub-title {
            font-size: 12px !important;
            line-height: 16px !important;
        }
    }
}
</style>
